import { Button, Col, Input, Popconfirm, Row, Select, message } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import API_HOST from "../config.js";
import { testProfile } from "./cancelFunction.js";

const countryOptions = [
  {label: 'Canada', value: 'CA'},
  {label: 'US', value: 'US'},
]
const zipCodeCAOptions = [
  {label: 'Alberta - T5Z 3M7', value: '9001379'},
  {label: 'Alberta - A0B 3A0', value: '9000001'},
  {label: 'Alberta - T0L 0Z0', value: '9001290'},
  {label: 'Alberta - T0H 1P0', value: '9001287'},
  {label: 'Alberta - T3E 7G7', value: '9001333'},
  {label: 'Alberta - T3C 0N3', value: '9001332'},
  {label: 'Alberta - T3G 5T4', value: '9001334'},
  {label: 'Alberta - T4A 2K3', value: '9001345'},
  {label: 'Alberta - T2K 3A4', value: '9001317'},
  {label: 'Alberta - T3Z 3J7', value: '9198662'},
]
const zipCodeUSOptions = [
  {label: 'Washington - 98003', value: '9033252'},
  {label: 'Washington - 98370', value: '9033458'},
  {label: 'Washington - 98535', value: '9033522'},
  {label: 'Washington - 99169', value: '9033770'},
  {label: 'Washington - 98569', value: '9033542'},
  {label: 'Washington - 98275', value: '9033394'},
  {label: 'Washington - 98001', value: '9033250'},
  {label: 'Washington - 99352', value: '9033822'},
  {label: 'Washington - 98926', value: '9033668'},
  {label: 'Washington - 99344', value: '9033815'},
]
const zipCodeOptions = {
  'US': zipCodeUSOptions,
  'CA': zipCodeCAOptions
}
function CreateAdAccount(props) {
  const [loading, setLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const [profileModel, setProfileModel] = useState(testProfile);

  const [quantity, setQuantity] = useState('5');
  const [tabsNo, setTabsNo] = useState('5');
  const [country, setCountry] = useState("US");
  const [zipcode, setZipcode] = useState('9033252');

  const create = async (profile) => {
    if(country?.length === 0 || zipcode?.length === 0){
      messageApi.error("Vui lòng chọn Quốc Gia và Zipcode");
      return
    }

    messageApi.info(`Profile: ${profile.name} >>> Tạo TK Local Nháp...`);
    let body = {
      profile: profile,
      quantity: +quantity,
      tabsNo: +tabsNo,
      country: Array.isArray(country) ? country[0] : country,
      zipcode: Array.isArray(zipcode) ? zipcode[0] : zipcode,
    };
    axios
      .post(`${API_HOST}/api/account/create-local-acc-draft`, body)
      .then((res) => messageApi.success("Đang chạy..."))
      .catch((e) => {
        console.log("🚀 ~ Tạo TK Local Nháp ~ e:", e);
        messageApi.error(e.response.data);
      });
  };

  const onOpenChange = (open) => {
    if (open) {
      setLoading(true);
      axios
        .get(`${API_HOST}/api/profiles/${props.profile.id}`)
        .then((res) => {
          setLoading(false);
          if (res.data) {
            setProfileModel(res.data[0]);
          }
        })
        .catch((e) => {
          setLoading(false);
          messageApi.error("Không thể lấy thông tin Profile");
        });
    }
  };
  useEffect(() => {
    let quantity = localStorage.getItem('acct-local-quantity')
    if (quantity) {
      setQuantity(quantity)
    }
    let tabsNo = localStorage.getItem('acct-local-tabsNo')
    if (tabsNo) {
      setTabsNo(tabsNo)
    }
    let country = localStorage.getItem('acct-local-country')
    if (country) {
      setCountry(country)
    }
    let zipcode = localStorage.getItem('acct-local-zipcode')
    if (zipcode) {
      setZipcode(zipcode)
    }

  }, [])

  return (
    <>
      {contextHolder}
      <Popconfirm
        style={{ minWidth: 500 }}
        onOpenChange={onOpenChange}
        placement="left"
        okText="OK"
        cancelText="Hủy"
        title="Xác nhận: Tạo TK Local Nháp "
        description={
          <>
            {profileModel?.errorMsg?.length > 0 && (
              <label style={{ color: "red", border: "1px solid red" }}>
                <strong>{profileModel?.errorMsg}</strong>
              </label>
            )}
            <Row>
              <Col span={5}>
                <label>Quốc Gia: </label>
              </Col>
              <Col span={19}>
                <Select
                  mode={"multiple"}
                  maxCount={1}
                  value={country}
                  style={{ width: 250 }}
                  placeholder="Quốc Gia ..."
                  options={countryOptions}
                  filterOption={(input, option) =>
                    (option.label || '').toLowerCase().includes(input.toLowerCase())
                  }
                  onChange={(value) => {
                    setCountry(value)
                    setZipcode(zipCodeOptions[value]?.[0]?.value || '')
                    localStorage.setItem("acct-local-country", value);
                  }}
                />
              </Col>
              <Col span={5}>
                <label>Zipcode: </label>
              </Col>
              <Col span={19}>
                <Select
                  mode={"multiple"}
                  maxCount={1}
                  value={zipcode}
                  style={{ width: 250 }}
                  placeholder="Zipcode ..."
                  options={zipCodeOptions[country] || []}
                  filterOption={(input, option) =>
                    (option.label || '').toLowerCase().includes(input.toLowerCase())
                  }
                  onChange={(value) => {
                    setZipcode(value)
                    localStorage.setItem("acct-local-zipcode", value);
                  }}
                />
              </Col>
       
              <Col span={5}>
                <label>Số Lượng: </label>
              </Col>
              <Col span={19}>
                <Input
                  value={quantity}
                  type="number"
                  style={{ width: 60 }}
                  placeholder="Số Lượng ..."
                  onChange={(e) => {
                    setQuantity(e.target.value)
                    localStorage.setItem("acct-local-quantity", e.target.value);
                  }}
                />
              </Col>
              <Col span={5}>
                <label>Số Tabs: </label>
              </Col>
              <Col span={19}>
                <Input
                  value={tabsNo}
                  type="number"
                  style={{ width: 60 }}
                  placeholder="Số Tabs ..."
                  onChange={(e) => {
                    setTabsNo(e.target.value)
                    localStorage.setItem("acct-local-tabsNo", e.target.value);
                  }}
                />
              </Col>

            </Row>

          </>
        }
        onConfirm={() => create(props.profile)}
      >
        <Button loading={loading}>
          Tạo TK Local Nháp
        </Button>
      </Popconfirm>
    </>
  );
}
export default CreateAdAccount;
